import { MEDIA } from './common'

// constants

export const CONTENT = {
  content: {
    '& a': { textDecoration: 'underline' },
    '& figure': { margin: [0, 0, 16] },
    '& img': { width: '50%' },
    '& p': { marginBottom: 16 },
    border: '1px solid transparent',
    marginLeft: 200,
    padding: [50, 0, 11, 124],
    width: 743
  },

  [MEDIA.mobile]: {
    content: {
      '& img': { width: '67%' },
      clear: 'left',
      float: 'left',
      height: 'auto',
      marginLeft: 0,
      maxHeight: 'none',
      padding: [32, 11, 0, 8],
      width: 314
    }
  },

  [MEDIA.tablet]: {
    content: { clear: 'both', marginLeft: 0, paddingRight: 11, width: 634 }
  }
}

export const DETAIL = {
  detail: {
    '&::after': { clear: 'both', content: '""', display: 'table' },
    margin: [0, 'auto'],
    padding: [0, 3, 32],
    width: 960
  },

  [MEDIA.mobile]: {
    detail: { width: 320 }
  },

  [MEDIA.tablet]: {
    detail: { width: 640 }
  }
}
